import React from 'react';

import { subscriber_profile_path } from '@routes';
import { ForumPost } from '@utils/backend-api/forumPosts';
import { PaginationType } from '@utils/backend-api/subscriber_directory';
import { POST_TYPE_FORUM_POSTS } from '@utils/constants';

import Pagination from '../../../Pagination';
import ForumPostListItem from '../ForumPostListItem';
import styles from './styles.module.scss';

export default function ForumPostList({
  forumPosts,
  paginationData,
  username,
}: {
  forumPosts: ForumPost[];
  paginationData?: PaginationType;
  username?: string;
}) {
  const getPath = (page: number) =>
    subscriber_profile_path(username, POST_TYPE_FORUM_POSTS, page === 1 ? undefined : page);

  return (
    <div className={styles.forumPosts}>
      {forumPosts?.map((forumPost) => (
        <ForumPostListItem forumPost={forumPost} key={forumPost.id} />
      ))}
      {paginationData?.totalPages > 1 && username && (
        <Pagination paginationData={paginationData} getPath={getPath} />
      )}
    </div>
  );
}
